/*************************************************************************
 *
 * KLEARNOW CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2020 KLEARNOW Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KLEARNOW Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KLEARNOW Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KLEARNOW Corporation.
 */

// import * as actions from '../actions/initializeValues';
// import { demoShipments } from '../util/demoShipments'
// import { dummyDataContainerInfo, coors } from '../util/testJSON'
// import { shipmentListData, shipmentActivityDetail, shipmentsCurrentLocation } from '../data/shipmentData'
import {
  saveSubHrdSectionField,
  saveContainerNumberField,
  removeContainerNumber
} from '../api/setFormData'

const initialState = {
  // initialValues
}

export default function SubHrdReducer(state = initialState, action) {
  switch (action.type) {
    case 'INITIALIZE_VALUES_SUBHRD': {
      return Object.assign({}, state, { ...action.payload })
    }

    case 'UPDATE_FIELD': {
      return Object.assign({}, state, { [action.field]: action.payload })
    }

    // Save Data
    case 'SAVE_SUBHRD_FIELD': {
      saveSubHrdSectionField(action.field, action.payload, state.requestId, action.formType)
      return state
    }
    case 'ADD_NEW_CONTAINER': {
      let containers = state.containers.slice()
      containers.unshift({"containerid": "", "containerNumber": ""})
      return Object.assign({}, state, { "containers": containers })
    }
    case 'REMOVE_CONTAINER': {
      let containers = state.containers.slice();
      let newContainer = containers.filter((item)=> {
        return item.containerid !== action.containerid
      })
      removeContainerNumber(action.containerid)
      return Object.assign({}, state, { "containers": newContainer })
    }
    case 'UPDATE_CONTAINER_NUMBER_FIELD': {
      let containers = state.containers.slice()
      let alphaPrefix = (action.containerNum).substr(0,4) || ""
      let containerNo = (action.containerNum).substr(4,6) || ""
      let checkDigit  = (action.containerNum).substr(10,1) || ""
      if(containers.length){
        containers.map(function(item){
          if(item.containerid === action.containerid){
            //let containerNumber = alphaPrefix + containerNo + checkDigit;
            item.containerNumber = containerNo
            item.checkdigit = checkDigit
            item.alphaprefix = alphaPrefix
          }
          return item;
        })
      }else{
        containers = [{
          "containerid": action.containerid, 
          "containerNumber": containerNo,
          "alphaprefix": alphaPrefix,
          "checkdigit": checkDigit
        }]
      }
      
      return Object.assign({}, state, { "containers": containers })
    }

    // Save Data
    case 'SAVE_CONTAINER_NUMBER_FIELD': {
      if(action.containerNum!=""){
        saveContainerNumberField(action.containerid, action.containerNum, state.requestId)
      }
      return state
    }

    case 'UPDATE_CONTAINER_ON_RESPONSE': {
      let containers = state.containers.slice()
      let newContainer = action.containers[0];
      containers.map(function(item){
        let containerNum = newContainer.alphaprefix+newContainer.containerNumber+newContainer.checkdigit;
        let containerNumber =  item.alphaprefix+item.containerNumber+item.checkdigit;
        if(containerNumber === containerNum && !item.containerid){
          item.containerid = newContainer.containerid;
        }
        return item;
      })
      return Object.assign({}, state, { "containers": containers })
    }
    
    default:
      return state
  }
}